/* import __COLOCATED_TEMPLATE__ from './hubspot-hovercard.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();